import axiosClient from '@clients/axiosClient';

export type IAccountHistoryItem = {
    account_id: number;
    customer_id: number;
    has_notes: boolean;
    initial_date: string;
    protocol: string;
    status: string;
    tenant: string;
    user: string;
    additional_info?: { [key: string]: string };
    end_date?: string;
};

export type IAccountHistory = {
    current_page: number;
    items: IAccountHistoryItem[];
    next_page: boolean;
    per_page: number;
};

export type IGetAccountHistoryDetails = {
    accountId: number;
    customerId: number;
    page?: number;
    perPage?: number;
};

const accountHistory = () => {
    const client = axiosClient();

    return {
        async getAccountHistory({
            accountId,
            customerId,
            page = 1,
            perPage = 1,
        }: IGetAccountHistoryDetails) {
            const { data } = await client.get<IAccountHistory>(
                `events/v1/customers/${customerId}/accounts/${accountId}/protocols`,
                {
                    params: { page, perPage },
                },
            );

            return data;
        },
    };
};

export default accountHistory;
